/**
 * <cart-reserve-timer>: countdown shown in the cart drawer message bar.
 * Session based: a new browser session starts from the full duration, and it restarts
 * when it reaches zero. The end time is kept in sessionStorage so it survives drawer
 * re-renders and page navigation within the session.
 */
if (!customElements.get('cart-reserve-timer')) {
  const STORAGE_KEY = 'cart-reserve-end';

  class CartReserveTimer extends HTMLElement {
    connectedCallback() {
      this.duration = Math.max(Number(this.dataset.minutes) || 5, 1) * 60000;
      this.end = this.#readEnd();
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    #readEnd() {
      let end = 0;
      try {
        end = Number(window.sessionStorage.getItem(STORAGE_KEY)) || 0;
      } catch (_) {
        end = 0;
      }
      if (!(end > Date.now()) || end - Date.now() > this.duration) end = this.#restart();
      return end;
    }

    #restart() {
      const end = Date.now() + this.duration;
      try {
        window.sessionStorage.setItem(STORAGE_KEY, String(end));
      } catch (_) {
        /* storage unavailable: still counts for this page view */
      }
      return end;
    }

    tick() {
      let diff = this.end - Date.now();
      if (!(diff > 0)) {
        this.end = this.#restart();
        diff = this.duration;
      }
      const total = Math.ceil(diff / 1000);
      const text = `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
      if (this.textContent !== text) this.textContent = text;
    }
  }

  customElements.define('cart-reserve-timer', CartReserveTimer);
}
